import { TrophyVariantOutlineIcon } from './TrophyVariantOutlineIcon';

/**
 * author: Simran
 * id C3A5133F-0462-40DB-863A-3659FC5DFE0E
 * name trophy-variant-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trophy-variant-outline.svg
 * tags
 * - Sport 
 */
export const AchievementVariantOutlineIcon = TrophyVariantOutlineIcon;
export default AchievementVariantOutlineIcon